import { useQuery } from '@tanstack/react-query';
import { getServiceConfiguration } from '@tmap-web-lib/remote-api-client/frontman';

import { APP_ENV } from '../constants/app-env';
import { KEYS } from '../react-query';

export interface ServiceMapping {
  service: Service;
  url: ServiceUrl;
  paths?: Record<PageId, PageIdPath>; // 각 페이지에 대한 path를 정의
  altUrl?: ServiceUrl;
  minVersion?: Version;
  maxVersion?: Version;
  iosMinVersion?: Version;
  iosMaxVersion?: Version;
  requestData?: string[];
  iosUrl?: string;
}

export type Mappings = ServiceMapping[];

const SERVICE_CONFIG_KEY_MAP: Record<string, string> = {
  dev: 'WEB_VERTICAL_BRIDGE_SERVICE_DEV',
  dtg: 'WEB_VERTICAL_BRIDGE_SERVICE_DTG',
  stg: 'WEB_VERTICAL_BRIDGE_SERVICE_STG',
  rtg: 'WEB_VERTICAL_BRIDGE_SERVICE_RTG',
  prd: 'WEB_VERTICAL_BRIDGE_SERVICE',
};

function getServiceConfigKey(): string {
  const target = APP_ENV.TARGET || 'prd';
  return SERVICE_CONFIG_KEY_MAP[target] || SERVICE_CONFIG_KEY_MAP.prd;
}

function useServicePageIdMapping() {
  const key = getServiceConfigKey();

  const { data, error, isLoading } = useQuery<Mappings, Error>({
    queryKey: KEYS.SERVICE_CONFIG(key),
    queryFn: async () => {
      const res = await getServiceConfiguration<Mappings>({
        key,
        limit: 1,
        offset: 0,
      });
      const contents = res.data?.data?.contents;
      if (contents && contents.length > 0) {
        return contents[0].data;
      }
      return [];
    },
  });

  return {
    mappings: data ?? null,
    loading: isLoading,
    error: error?.message ?? null,
  };
}

export default useServicePageIdMapping;
